import { render } from "./ForTeamsPage.vue?vue&type=template&id=5690d504&scoped=true"
const script = {}

import "./ForTeamsPage.vue?vue&type=style&index=0&id=5690d504&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5690d504"]])

export default __exports__